import { GraphQLClient } from 'graphql-request';
import { getSdk } from '@src/generated/graphql';

const client = new GraphQLClient(process.env.NEXT_PUBLIC_SANITY_URL ?? '', {
  headers: {
    Authorization: `Bearer ${process.env.NEXT_PUBLIC_SANITY_AUTH}`,
  },
});
const sdk = getSdk(client);

export default sdk;
